// @flow

import styled from 'styled-components';
import { theme } from '../theme';

export const Input = styled.input.attrs({ type: 'text' })`
  height: 3em;
  border-radius: 0.4em;
  box-shadow: 0 0 0 0 transparent inset;
  line-height: 2em;
  font-size: 1em;
  outline: 0;
  padding: 0.7em 1em;
  padding-right: 1em;
  padding-left: 1em;
  border: 1px solid;
  transition: color 0.1s ease, border-color 0.1s ease;

  background-color: white;
  border-color: ${theme.colors.gray(79)};
  color: ${theme.colors.gray(0, 0.87)};

  :focus {
    color: ${theme.colors.gray(0, 0.8)};
    border-color: ${theme.colors.blue(48)};
  }

  ::placeholder {
    color: ${theme.colors.gray(0, 0.4)};
  }
`;
